import { CMS } from "../modules";

export const CMSPage = () => {
  return <CMS />;
};
